import React, { useEffect, useState } from "react";
import { PARTNER_API } from "../../../../Utilities/APIs";

import Form from "../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import ImageInput from "../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import FormSubmitButton from "../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import useAxiosInstance from "../../../../Utilities/Hooks/useAxiosInstance";

function UpdatePartner({ targetID, triggerFetch, setShowUpdateForm, setShowModal }) {
  const [name, setName] = useState("");
  const [precedence, setPrecedence] = useState("");
  const [image, setImage] = useState("");
  const axiosInstance = useAxiosInstance();

  useEffect(() => {
    async function fetchAndSetPartnerInfo() {
      const { data } = await axiosInstance.get(PARTNER_API + targetID);
      setName(data.name);
      setPrecedence(data.precedence);
      setImage(data.image);
    }
    fetchAndSetPartnerInfo();
  }, [targetID, axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();
    itemData.append("name", name);
    itemData.append("precedence", precedence);
    itemData.append("image", image);

    const response = await axiosInstance.patch(PARTNER_API + targetID, itemData);

    if (response) {
      setShowUpdateForm(false);
      setShowModal(false);
      triggerFetch();
    }
  }

  return (
    <Form onSubmit={handleSubmit} hasImage>
      <ShortTextInput
        label="Name"
        value={name}
        placeholder="Enter Name"
        setState={setName}
      />
      <ShortTextInput
        label="Precedence"
        value={precedence}
        placeholder="Enter Precedence"
        setState={setPrecedence}
      />
      <ImageInput
        fieldId="1"
        state={image}
        setState={setImage}
        allowUpdateImage
      >
        Upload Image
      </ImageInput>

      <FormSubmitButton text="Update" />
    </Form>
  );
}

export default UpdatePartner;
